import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MessagesRoutingModule } from './messages-routing.module';
import { MessagesComponent } from './messages.component';
import { FeaturesCommonModule } from 'src/app/features-common/features-common.module';
import { AgGridModule } from 'ag-grid-angular';
import { ComposeNewComponent } from './compose-new/compose-new.component';
import { MessagesSmartComponent } from './messages-smart.component';
import { ViewMessageComponent } from './view-message/view-message.component';
import { ComposeBulkComponent } from './compose-bulk/compose-bulk.component';


@NgModule({
  declarations: [MessagesComponent, ComposeNewComponent, MessagesSmartComponent, ViewMessageComponent, ComposeBulkComponent],
  imports: [
    MessagesRoutingModule,
    FeaturesCommonModule,
    AgGridModule.withComponents([]),
  ],
})
export class MessagesModule { }
